module.exports = __webpack_public_path__ + "img/logo-ibs.e4af04b0.png";